import React, { useEffect } from "react";
import "./About.css";
import heritageImg from "../../assets/heritageImg.webp";
import lohiImg from "../../assets/lohi.jpg";
import modernImg from "../../assets/modern.avif";
import kurta2 from "../../assets/kurta2.jpg";
import kurta3 from "../../assets/kurta3.webp";
import kurta4 from "../../assets/kurta4.jpg";
import base_url from '../../../src/api';
const AboutUs = () => {
  return (
    <section className="about-section">
      {/* Heading */}
     
      <div className="about-footer">
        <h2>
          Welcome to <span className="brand">Shawl Haus</span>
        </h2>
        <p>
          Where heritage is worn with pride, and every drape tells a story.
        </p>
      </div>

      <div className="about-header">
        <p>
          At <span className="brand">Shawl Haus</span>, we’re on a mission to
          preserve and reintroduce the timeless tradition of the Punjabi men’s
          shawl (lohi) to the modern world. Rooted in the rich cultural heritage
          of Punjab and crafted for today’s discerning man, our shawls are more
          than garments—they are statements of identity, pride, elegance, and
          legacy.
        </p>
      </div>

      {/* First Row */}
      <div className="about-row">
        <div className="about-text">
          <h2>
            <span>Our</span>
            <span className="brand"> Roots</span>
          </h2>
          <p>
            Inspired by the royal lohis of Punjab and the warmth of ancestral
            craftsmanship, each shawl in our collection embodies both cultural
            depth and contemporary sophistication.
          </p>
          <p>
            Every piece we design pays homage to the artisans whose hands have
            carried forward this centuries-old craft, blending heritage with
            modern sensibilities to create something truly timeless.
          </p>
        </div>
        <div 
          className="about-image"
          style={{ backgroundImage: `url(${kurta4})` }}
        >
        </div>
      </div>

      {/* Second Row */}
      <div className="about-row reverse">
        <div 
          className="about-image about-2"
          style={{ backgroundImage: `url(${kurta2})` }}
        >
        </div>
        <div className="about-text">
          <h2>
            <span>Our</span>
            <span className="brand"> Collections</span>
          </h2>
          <p>
            From classic lohis and intricate embroidered pieces to modern
            interpretations, our shawls are thoughtfully curated to represent
            dignity, warmth, and refined style. Each one is designed for those
            who value both culture and sophistication.
          </p>
          <p>
            To complete the look, we also offer a curated selection of kurtas
            that harmonize perfectly with our shawls—bringing together textures,
            colors, and elegance into one timeless ensemble.
          </p>
        </div>
      </div>

      {/* Third Row */}
      <div className="about-row">
        <div className="about-text">
          <h2>
            <span>Our</span>
            <span className="brand"> Mission</span>
          </h2>
          <p>
            Our mission is simple: to honor tradition while creating a space
            where culture meets fashion. Whether you’re dressing for a wedding,
            a celebration, or simply elevating your everyday wardrobe, our
            shawls are designed to make you feel confident, connected, and
            proud.
          </p>
          <p>
            Welcome to <span className="brand">Shawl Haus</span>—where every
            drape tells a story, every thread carries heritage, and every piece
            is crafted with pride.
          </p>
        </div>
        <div 
          className="about-image about-3"
          style={{ backgroundImage: `url(${kurta3})` }}
        >
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
